import React from 'react';
import styles from './Button.module.css';

const Button = ({ variant = '', children, className = ''}) => {
  
    let variantClass; 
    
    if(variant === 'normal'){
        variantClass = styles.normal;
    } else if(variant === 'transparent'){
       variantClass = styles.transparent;
    } else if(variant === 'gradient'){
        variantClass = styles.gradient;
    }


    // Combina a classe base, a classe da variante e quaisquer classes personalizadas
    const combinedClasses = `${styles.button} ${variantClass} ${className}`.trim();
  
    return (
      <button className={combinedClasses}>
        {children}
      </button>
    );
  };
  
  export default Button;